import React, {useEffect, useState} from 'react';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {useHistory} from 'react-router-dom';
import './styles.scss';
import {compose} from 'redux';
import * as fonts from '../../util/fonts';
import AppWrapper from '../../components/app-wrapper';
import Icon from '../../components/icon';
import {Column, Row} from '../../components/layout';
import {strings} from '../../util/strings';
import {addToGlobalStyles, addToWizard, setUser} from '../../store/actions';
import ContainerDocumentDownload from './../../components/container-document-download/index';
import {get, getBlob} from '../../api/api';
import Header1 from '../../components/headers/header1';
import colors from '../../util/colors';
import {uriGetIrsLast3Years, uriGetTheIRSpdf} from '../../api/endpoints';
import {Icons} from '../../util/icons';
import AppSpinner from '../../components/app-spinner';
import ModalTemplate from '../../components/modal';

interface IrsDeclarationProps {
  user: any;
  addToGlobalStyles(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.IRS;
  setUser(value: any): void;
  addToWizard(value: any): void;
  messageLabels: typeof strings.pt.messages;
}

function IrsDeclaration({
  user,
  labels,
  setUser,
  selectedBu,
  messageLabels,
}: IrsDeclarationProps) {
  const history = useHistory();
  const [submittedFiles, setSubmittedFiles] = useState<any>([]);
  const [infoForIrs, setInfoForIrs] = useState<any>();
  const [filterShouldRefresh, setFilterShouldRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showError, setShowError] = useState(false);

  const featureName = 'IrsDeclarationList';

  useEffect(() => {
    async function getInfo() {
      setIsLoading(true);
      try {
        await get(
          uriGetIrsLast3Years(selectedBu.buId, selectedBu.memId),
          false,
          0,
          featureName
        ).then((res: any) => {
          setInfoForIrs(res?.data?.items);
        });
      } catch (e: any) {
        setInfoForIrs(undefined);
      } finally {
        setIsLoading(false);
      }
    }
    getInfo();
    return function cleanup() {};
  }, [selectedBu.memId]);

  useEffect(() => {
    setFilterShouldRefresh(true);
  }, [selectedBu]);

  return (
    <>
      <Column>
        <Row className="irs-title-row p-0 mb-0">
          <p
            className="m-0"
            style={{...fonts.XL, ...fonts.Bold, color: colors.black}}>
            {labels?.IRS_title}
          </p>
        </Row>
        <Row className="irs-title-row p-0 mb-0">
          <p style={{...fonts.M, color: colors.black}}>{labels?.IRS_text}</p>
        </Row>
        {!isLoading && infoForIrs !== undefined && infoForIrs?.length > 0 && (
          <Row className="container-download-row justify-content-center m-3 mb-5">
            <ContainerDocumentDownload
              title=""
              documentIds={infoForIrs}
              isIrsDeclaration={true}
              setShowError={(error: boolean) => setShowError(error)}
            />
          </Row>
        )}
        {!isLoading &&
          (infoForIrs === undefined || infoForIrs?.length === 0) && (
            <Column className="container-no-irs">
              <Icon
                name={Icons.ALERT_PROBLEM}
                color={colors.lightGrey}
                width="40"
                height="40"
                changeViewbox={false}
              />
              <h6
                style={{color: colors.lightGrey, marginTop: 20, width: '50%'}}>
                {labels?.irs_emptyList}
              </h6>
            </Column>
          )}
        {isLoading && (
          <AppSpinner
            style={{
              width: 'fit-content',
              margin: 'auto',
              marginTop: '5%',
              marginBottom: '10%',
            }}></AppSpinner>
        )}
      </Column>
      <ModalTemplate
        type="error"
        show={showError}
        onHide={() => setShowError(false)}
        hideFooter={true}
        cross={true}>
        <p style={{color: colors.alertRed, fontWeight: 'bold'}}>
          {messageLabels?.general_errorMessage}
        </p>{' '}
      </ModalTemplate>
    </>
  );
}

const mapStateToProps = ({selectedBu, user, strings, wizard}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.IRS,
  wizard: wizard.value,
  messageLabels: strings.value.pt.messages,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setUser: (value: any) => dispatch(setUser(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(IrsDeclaration)
);
